import React, {useState} from 'react';
import {Formik, Field, FormikProps, FormikHelpers, ErrorMessage} from 'formik';

import {Button, Form, Popup} from '@components';
import mappings from '@mappings';
import utils from '@utils';
import validations from '@validations';
import constants from '@constants';
import {Props} from './types';
import * as hooks from './hooks';
import * as handlers from './handlers';

import './index.scss';

const Main: React.FC<Props> = props => {
  const [initialValues, setInitialValues] = useState({});
  hooks.useMount(props.me, setInitialValues);

  return (
    <div className="a__mypage-disaster">
      <div className="b__title">自動送信設定</div>
      <div className="w__field">
        <div className="b__auto-sending">
          <div className="b__field">
            <div className="b__field-title">自動送信</div>
            <Form.Label text="条件" required />
            <Formik
              initialValues={initialValues}
              onSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
                handlers.updateSetting(values, formikHelpers, props.me)
              }
              enableReinitialize
              validate={validations.teams.updateSettings}
            >
              {(formProps: FormikProps<any>) => {
                return (
                  <>
                    <div className="w__selection">
                      <Field
                        component={Form.Dropdown}
                        name="intensity"
                        options={utils.mappings.createSelections(
                          mappings.conditions
                        )}
                      />
                      <span>の時に通知</span>
                    </div>
                    <Form.Label text="通知手段" required />
                    <div className="w__checkbox">
                      <Field
                        component={Form.Checkbox}
                        label="メール"
                        name="isEmailSending"
                        disabled={props.me.plan === constants.PLAN.FREE}
                      />
                      <Field
                        component={Form.Checkbox}
                        label="SMS"
                        name="isSMSSending"
                        disabled={!props.me.plan}
                      />
                      {props.me.plan === constants.PLAN.FREE && (
                        <Popup.Normal content="無料プランでは、Eメールでのみ安否確認を送信できます" />
                      )}
                    </div>
                    <ErrorMessage
                      name="isEmailSending"
                      component={Form.Error}
                    />
                    <div className="w__setting-button">
                      <Button.Normal
                        color="yellow"
                        text="設定を保存する"
                        disabled={formProps.isSubmitting}
                        loading={formProps.isSubmitting}
                        onClick={() => {
                          formProps.handleSubmit();
                        }}
                      />
                    </div>
                  </>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
